import React from 'react'
import { Modal, Text } from '@components/common'

interface ProductionUnitsSkippedPeriodModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
}

const ProductionUnitsSkippedPeriodModal: React.FC<ProductionUnitsSkippedPeriodModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title="Skipped Periods Detected"
      close={onClose}
      actionLabel="Continue"
      action={onConfirm}
      isActionLoading={isLoading}
      width={500}
      intent="default"
    >
      <Text>
        You are adding a production units record that will create gaps in the sequence. The
        system will automatically create records with zero units produced for any skipped
        periods.
      </Text>
    </Modal>
  )
}

export default ProductionUnitsSkippedPeriodModal
